import contact from './contact/state/reducer';

export default {
  contact,
};
